var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShow,
            expression: "isShow",
          },
        ],
        staticClass: "ui-sticky-bet",
      },
      [
        _c("div", { staticClass: "sticky-bet" }, [
          _c("div", { staticClass: "sticky-bet__content" }, [
            _c(
              "div",
              {
                staticClass: "sticky-bet__hide hide-arrow",
                on: { click: _vm.toggle },
              },
              [_vm._m(0)]
            ),
            _c("div", { staticClass: "crash-sticky-bet-content" }, [
              _c(
                "div",
                { staticClass: "crash-bet-content" },
                [_vm._t("default")],
                2
              ),
            ]),
          ]),
        ]),
      ]
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isShow,
            expression: "!isShow",
          },
        ],
        staticClass: "ui-sticky-bet",
      },
      [
        _c("div", { staticClass: "sticky-bet" }, [
          _c("div", { staticClass: "sticky-bet__toggler" }, [
            _c(
              "div",
              {
                staticClass: "crash-sticky-bet-toggler",
                on: { click: _vm.toggle },
              },
              [_vm._m(1)]
            ),
          ]),
          _c("div", { staticClass: "sticky-bet__bets" }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hide-arrow__button" }, [
      _c("span", { staticClass: "text" }, [_vm._v("最小化")]),
      _c("span", { staticClass: "icon icon_arrow-triangle-alt" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "crash-bet-toggler" }, [
      _c("div", { staticClass: "crash-bet-toggler__text" }, [_vm._v("进入")]),
      _c("div", { staticClass: "crash-bet-toggler__icon icon icon_plus-bold" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }